import { useQuery } from "urql";

import { GetCustomerLateChargeFeeDocument } from "../../../graphql/generated.ts";

export function useCustomerLateChargeFee() {
  return useQuery({
    query: GetCustomerLateChargeFeeDocument,
  });
}
